<template>
  <div :class="jel_getClassObject(content)">
    <Titre
      :content="{
        titre: content.titreVerification,
        type: 'titre',
      }"
    />
    <template v-if="isContenuAffiche">
      <MessageMel
        v-if="isErreurSessionExpire && contentMessage.sessionExpire"
        class="mb-2 mt-1"
        :content="contentMessage.sessionExpire"
      />

      <MessageMel
        v-if="isErreurRecuperation && contentMessage.recuperation"
        class="mb-1"
        :content="contentMessage.recuperation"
      />
      <template v-else>
        <!-- Section Vérification en 2 étapes -->
        <template>
          <!-- Si il y a un MFA actif -->
          <template v-if="mfaBase">
            <div v-html="content.libMfaActive" />
            <MessageMel
              v-if="isErreurReinitialisationRetirer && contentMessage.reinitialisationRetirer"
              class="mt-1 mb-0"
              :content="contentMessage.reinitialisationRetirer"
            />
            <div class="liste pt-2">
              <div class="defaut">
                <span>
                  {{
                    mfaBase.type === 'totp'
                      ? content.libOptionAuthenticator
                      : `${content.libOptionTelephone} ***${
                          $i18n.locale == 'en' ? '-' : ' '
                        }***-${mfaBase?.phone_number.slice(-4)}`
                  }}
                </span>
              </div>
            </div>
            <div class="mt-1">
              <button class="bouton lienPrimaire p-0" @click="afficherModaleModifierMfa()">
                {{ content.libLienModifierVerification }}
              </button>
            </div>
          </template>
          <!-- Si il n'y a pas de MFA actif -->
          <template v-else>
            <MessageMel
              v-if="isErreurClearChoice && contentMessage.clearChoice"
              class="mt-1 mb-0"
              :content="contentMessage.clearChoice"
            />

            <div v-if="isBiometrieActive" v-html="content.libActiverMfaBiometrieActive" />
            <div v-else v-html="content.libMfaDesactive" />
            <MessageMel
              v-if="isErreurReconnexion && contentMessage.reconnexion"
              class="my-1"
              :content="contentMessage.reconnexion"
            />
            <template v-else>
              <Hyperlien v-if="content.libTexteAide" :content="contentLienAide" />
              <button class="bouton lienPrimaire p-0 mt-1" @click="verificationMFA()">
                {{ content.libActiverVerification }}
              </button>
            </template>
            <MessageMel
              v-if="isErreurActivation && contentMessage.activation"
              class="mt-1 mb-0"
              :content="contentMessage.activation"
            />
          </template>
        </template>
        <!-- Section Appareils enregistrés -->
        <template v-if="content.activerBiometrie === 'true'">
          <Titre
            :content="{
              titre: content.titreAppareil,
              type: 'titre',
            }"
          />
          <div v-if="isAppareilRetireSucces" class="mb-1">
            <span class="d-inline-flex cercleSucces cercleSucces-contenu m-0">
              {{ '&#10003;' }}
            </span>
            <span class="pl-1" v-html="content.libAppareilRetireSucces" />
          </div>
          <div class="mb-0" v-html="content.libAppareil" />

          <MessageMel
            v-if="isErreurRetirer && contentMessage.retirer"
            class="mb-0 mt-1"
            :content="contentMessage.retirer"
          />
          <div class="w-100 liste pt-2">
            <div v-if="!isBiometrieActive" class="defaut">
              <span>{{ content.libAucunAppareil }}</span>
            </div>
            <template v-else>
              <div v-for="appareil in listeBiometrie" :key="appareil.mfa_id" class="appareil">
                <span>{{ appareil.device_name }}</span>
                <button
                  class="bouton-appareil lienPrimaire float-right p-0"
                  @click="afficherModaleRetirerAppareil(appareil)"
                >
                  {{ content.libLienRetirerAppareil }}
                </button>
              </div>
            </template>
          </div>
        </template>
        <b-modal
          v-model="isAfficherModale"
          :hide-footer="true"
          dialog-class="d-flex align-items-center h-100"
          header-class="d-none"
          body-class="compteClair"
        >
          <Titre
            :content="{
              titre: modaleTitre,
              type: 'titre',
            }"
          />
          <div v-if="modaleTexte" v-html="modaleTexte" />
          <div class="modale-boutons">
            <b-button class="btn btn-primaire px-4 mt-2 mb-1" @click="confirmerModale()">
              <span>{{ content.libModaleBoutonConfirmer }}</span>
            </b-button>
            <button class="bouton-secondaire lienSecondaire" @click="isAfficherModale = false">
              {{ content.libModaleBoutonAnnuler }}
            </button>
          </div>
        </b-modal>
      </template>
    </template>
  </div>
</template>

<script>
import Cookies from 'js-cookie';
import api from '@/services/api';
import session from '@/services/api/compte/session';
import { returnConnexion } from '@/helpers/RouteHelpers';

import Hyperlien from '@/components/base/Hyperlien';
import MessageMel from '@/components/base/MessageMel';
import Titre from '@/components/base/Titre';

import MessageHelpers from '@/helpers/MessageHelpers';

export default {
  name: 'FormulaireSecuriteVerification',
  components: {
    Hyperlien,
    MessageMel,
    Titre,
  },
  props: { content: { type: Object, required: true } },
  data() {
    return {
      isAppareilRetireSucces: false,
      isAfficherModale: false,
      isRetirerMfa: false,
      isContenuAffiche: false,
      choixModale: [],
      isErreurActivation: false,
      isErreurClearChoice: false,
      isErreurReconnexion: false,
      isErreurRecuperation: false,
      isErreurReinitialisationRetirer: false,
      isErreurRetirer: false,
      isErreurSessionExpire: false,
      isReinitialisation: false,
      modaleTexte: '',
      modaleTitre: '',
      verification: [],
      contentMessage: {
        activation: {},
        clearChoice: {},
        reconnexion: {},
        recuperation: {},
        reinitialisationRetirer: {},
        retirer: {},
        sessionExpire: {},
      },
    };
  },
  computed: {
    contentLienAide() {
      return {
        texte: this.content.libTexteAide,
        type: 'aide',
        lien: this.content.lien,
      };
    },
    mfaBase() {
      const listeMFa = this.verification?.filter((item) => {
        return item.type === 'totp' || item.type === 'phone';
      });
      return listeMFa[0];
    },
    listeBiometrie() {
      return this.verification?.filter((item) => {
        return item.type === 'webauthn-platform';
      });
    },
    isBiometrieActive() {
      return this.listeBiometrie.length > 0;
    },
  },
  mounted() {
    api
      .call('ce-portal/portal_api/account/account/mfa', 'mfaGet', 'GET', {
        withCredentials: true,
      })
      .then((response) => {
        this.verification = response.data;
        this.isContenuAffiche = true;
      })
      .catch((error) => {
        if (!this.isSessionExpire(error.response?.data)) {
          if (error.response?.data?.errorCode === 'CUST_NOT_FOUND') {
            this.isErreurReconnexion = true;
            // Erreur du client non trouvé sur récupération des infos du compte
            this.recupererMessage('MSG06-20', 'reconnexion');
          } else {
            // Erreur générique sur récupération des infos du compte
            this.isErreurRecuperation = true;
            this.recupererMessage('MSG06-21', 'recuperation');
          }
        }
        this.isContenuAffiche = true;
      });
  },
  methods: {
    afficherModaleModifierMfa() {
      this.choixModale = this.mfaBase;
      this.isAfficherModale = true;
      this.isReinitialisation = true;
      this.isRetirerMfa = true;
      if (this.isBiometrieActive) {
        this.modaleTitre = this.content.libModaleTitreModifierVerificationBiometrieActive;
        this.modaleTexte = this.content.libModaleTexteModifierVerificationBiometrieActive;
      } else {
        this.modaleTitre = this.content.libModaleTitreModifierVerification;
        this.modaleTexte = this.content.libModaleTexteModifierVerification;
      }
    },
    afficherModaleRetirerAppareil(appareil) {
      this.choixModale = appareil;
      this.isAfficherModale = true;
      this.isRetirerMfa = true;
      this.modaleTitre = this.content.libModaleTitreRetirerAppareil.replace(
        '{{appareil}}',
        appareil.device_name
      );
      this.modaleTexte = '';
    },
    confirmerModale() {
      this.isAfficherModale = false;
      this.isRetirerMfa = false;
      this.supprimerMfa();
    },
    verificationMFA() {
      if (this.isBiometrieActive) {
        this.clearChoiceMfa();
      } else {
        this.activationMfa();
      }
    },
    activationMfa() {
      api
        .call(`ce-portal/portal_api/account/account/mfa/enrollment-link`, 'mfaActivation', 'POST', {
          withCredentials: true,
          headers: {
            'X-CSRF-TOKEN': Cookies.get('OB_REQ'),
          },
          data: {
            lang: this.$i18n.locale,
          },
        })
        .then((response) => {
          window.location.href = response.data.enrollment_url;
        })
        .catch((error) => {
          if (!this.isSessionExpire(error.response?.data)) {
            this.isErreurActivation = true;
            this.recupererMessage('MSG06-41', 'activation');
          }
        });
    },
    clearChoiceMfa() {
      api
        .call(`ce-portal/portal_api/account/account/details`, 'mfaClearChoice', 'PATCH', {
          withCredentials: true,
          headers: {
            'X-CSRF-TOKEN': Cookies.get('OB_REQ'),
          },
          data: {
            clear_mfachoicedate: 1,
          },
        })
        .then((response) => {
          session.fermerSession().then(() => {
            returnConnexion();
          });
        })
        .catch((error) => {
          if (!this.isSessionExpire(error.response?.data)) {
            this.isErreurClearChoice = true;
            this.recupererMessage('MSG06-40', 'clearChoice');
            if (this.isReinitialisation) {
              this.supprimerMfaListe();
              this.isReinitialisation = false;
            }
          }
        });
    },
    supprimerMfa() {
      api
        .call(
          `ce-portal/portal_api/account/account/mfa/${encodeURI(this.choixModale.mfa_id)}`,
          'mfaDelete',
          'DELETE',
          {
            withCredentials: true,
            headers: {
              'X-CSRF-TOKEN': Cookies.get('OB_REQ'),
            },
          }
        )
        .then((response) => {
          // Suppression du MFA sur réinitialisation
          if (this.isReinitialisation) {
            this.isErreurReinitialisationRetirer = false;
            this.verificationMFA();
          } else {
            // Suppression d'appareil biométrique
            if (this.mfaBase !== this.choixModale) {
              // Afficher message de succès sur un appareil retiré uniquement
              this.isAppareilRetireSucces = true;
            }
            this.supprimerMfaListe();
            this.isErreurRetirer = false;
          }
        })
        .catch((error) => {
          if (!this.isSessionExpire(error.response?.data)) {
            if (this.isReinitialisation) {
              // Erreur sur la suppression lors de la réinitialisation du mfa
              this.isReinitialisation = false;
              this.isErreurReinitialisationRetirer = true;

              this.recupererMessage('MSG06-30', 'reinitialisationRetirer');
            } else {
              // Erreur de la suppression d'un appareil
              this.isAppareilRetireSucces = false;
              this.isErreurRetirer = true;
              this.isReinitialisation = false;
              this.recupererMessage('MSG06-31', 'retirer');
            }
          }
        });
    },
    supprimerMfaListe() {
      this.verification.splice(this.verification.indexOf(this.choixModale), 1);
    },
    recupererMessage(codeMessage, contentMessage) {
      MessageHelpers.obtenirMessage(codeMessage, this.$root)
        .then((msgResp) => {
          this.contentMessage[contentMessage] = {
            titre: msgResp.msgTitre,
            message: msgResp.msgDetail,
            msgType: msgResp.msgType,
          };
        })
        .catch((error) => {
          console.error('Erreur de récupération du message!', error);
        });
    },
    isSessionExpire(error) {
      if (error?.status === 'Unauthorized') {
        this.isErreurSessionExpire = true;
        this.recupererMessage('MSG06-00', 'sessionExpire');
        return true;
      }
      return false;
    },
  },
};
</script>

<style lang="scss" scoped>
.liste {
  :first-child:not(span),
  .defaut {
    border-top: 1px solid lightblue;
  }
  .appareil,
  .defaut {
    border-bottom: 1px solid lightblue;
    padding-top: 6px;
    padding-bottom: 6px;
  }
}
.bouton {
  border: none !important;
  font-size: 16px;
}
.bouton-appareil {
  border: none !important;
  font-size: 14px;
}
.bouton-secondaire {
  border-left: none;
  border-right: none;
  border-top: none;
  background-color: transparent;
}
.modale-boutons {
  display: grid;
  justify-items: center;
}

::v-deep {
  p:last-child {
    margin: 0;
  }
  .modal-body {
    padding: 32px 28px;
    .titre {
      padding-top: 0;
    }
  }
}
</style>
